import React, {useContext} from 'react'
import events from 'events-bus'
import {ReactComponent as AngleDownIcon} from '@shop/icon-fonts/optimized/angle-down-small.svg'
import AppContext from '../../context'
import {AccessibleText, DEVICE_TYPES} from '../../utils'
import * as SC from './Multilanguage.styled'
import {InlinedPrimaryIcon} from '../Icon/Icon.styled'

export const MULTILANGUAGE_CLASS = 'srh-multilanguage'
export const MULTILANGUAGE_CHANGE_EVENT = 'MULTILANGUAGE-CHANGE-v1'

const Multilanguage = () => {
  const {translations, device, availableLanguages} = useContext(AppContext)
  const isSmallView = device === DEVICE_TYPES.SMARTPHONE || device === DEVICE_TYPES.PHABLET
  const isMediumView = device === DEVICE_TYPES.TABLET
  const selectedLanguage = availableLanguages.find(lang => lang.isSelected)

  const onChangeLanguage = (locale) => {
    const data = {
      version: 1,
      locale
    }
    events.trigger(MULTILANGUAGE_CHANGE_EVENT, data)
  }

  const LANGUAGE_BUTTONS = availableLanguages.map((language, index) => (
    <SC.LanguageButton
      className={`${MULTILANGUAGE_CLASS}-${language.locale}`}
      key={index}
      type={language.isSelected ? 'primary' : 'tertiary'}
      onClick={() => onChangeLanguage(language.locale)}
    >
      {language.displayLanguage}
      <AccessibleText id="shopHeaderAccountFlyoutDescription">
        {translations.get('shop.header.multilanguage.accessible.text').replace('${language}', language.displayLanguage)}
      </AccessibleText>
    </SC.LanguageButton>
  ))

  if (isSmallView) {
    return (
      <SC.SmallWrapper className={MULTILANGUAGE_CLASS}>
        {LANGUAGE_BUTTONS}
      </SC.SmallWrapper>
    )
  }

  if (isMediumView) {
    return (
      <SC.MediumWrapper>
        {selectedLanguage.displayLanguage}
        <InlinedPrimaryIcon>
          <AngleDownIcon />
        </InlinedPrimaryIcon>
        <div className="multiLanguage_flyout">
          {LANGUAGE_BUTTONS}
        </div>
      </SC.MediumWrapper>
    )
  }

  return (
    <div className={MULTILANGUAGE_CLASS}>
      {LANGUAGE_BUTTONS}
    </div>
  )
}

export default Multilanguage
